<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">常规工单</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!showIsDetail && !showIsAdd">
      <section class="searchBox">
        <span class="addStyle">
          <a-button v-show="!showIsSearch" @click="showIsSearch = true"
            >显示更多</a-button
          >
          <a-button v-show="showIsSearch" @click="showIsSearch = false"
            >隐藏更多</a-button
          >
          <a-button
            @click="showIsAdd = !showIsAdd"
            style="margin-right: 20px"
            type="primary"
            icon="plus"
            >增加临时工单</a-button
          >
        </span>
        <span v-show="showIsSearch">
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:200px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}</a-select-option
            >
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <label>状态：</label>
          <a-select v-model="status" style="width:120px">
            <a-select-option :value="10">待完成</a-select-option>
            <a-select-option :value="1">待审核</a-select-option>
            <a-select-option :value="2">已通过</a-select-option>
            <a-select-option :value="3">已驳回</a-select-option>
          </a-select>
        </span>
        <span>
          <label>工单类型：</label>
          <a-select v-model="type" style="width:120px">
            <a-select-option :value="10">临时</a-select-option>
            <a-select-option :value="1">补货</a-select-option>
            <a-select-option :value="2">上新</a-select-option>
            <a-select-option :value="3">美陈</a-select-option>
          </a-select>
        </span>
        <span v-show="showIsSearch">
          <a-select v-model="date_type" style="width: 120px;margin-right:6px;">
            <a-select-option :value="2">完成日期</a-select-option>
            <a-select-option :value="1">创建日期</a-select-option>
          </a-select>
          <a-range-picker
            style="width:200px"
            v-model="dateVal"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="网点设备机器名称|网点详细地址|工单号"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button
            v-show="showIsSearch"
            class="resetStyle"
            @click="downloadCost"
          >
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="(item, j) in thList" :key="j">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.create_time }}</td>
              <td>{{ item.project_name }}</td>
              <td>{{ item.device_name }}</td>
              <td>
                <p v-show="item.type == 1">补货</p>
                <p v-show="item.type == 2">上新</p>
                <p v-show="item.type == 3">美陈</p>
                <p v-show="item.type == 10">临时</p>
              </td>
              <td>{{ item.user_name }}</td>
              <td>
                <p v-show="item.status == 10">待完成</p>
                <p v-show="item.status == 1">待审核</p>
                <p v-show="item.status == 2">已通过</p>
                <p v-show="item.status == 3">已驳回</p>
              </td>
              <td class="operation">
                <a @click="detailPage(item)" style="color:#666">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 增加 -->
    <addMachineOrder v-show="showIsAdd" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end -->
    <!-- 详情 -->
    <machineOrderDetail
      v-show="showIsDetail"
      :detailVal="detailVal"
      v-on:hideIsDetail="hideIsDetail"
    />
    <!-- 详情 end -->
  </div>
</template>
<script>
import axios from "axios";
import addMachineOrder from "@/components/equipment/addMachineOrder"; //增加
import machineOrderDetail from "@/components/equipment/machineOrderDetail"; //详情
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "工单日期",
        "项目名称",
        "设备网点",
        "类型",
        "员工",
        "状态",
        "操作"
      ],
      version: "",
      showIsAdd: false,
      proList: [],
      showIsEdit: false,
      editDetail: "",
      showIsDetail: false,
      detailVal: "",
      project_id: "",
      query_field: "",
      status: "",
      type: "",
      showIsSearch: false,
      date_type: 1,
      dateVal: null,
      start_date: "",
      end_date: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addMachineOrder,
    machineOrderDetail
  },
  mounted() {
    this.getData(); //获取列表
    this.getPro();
  },
  methods: {
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          trade_id: 2,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
    },
    downloadCost() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Work_order/downloadOrder?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&status=" +
        this.status +
        "&type=" +
        this.type +
        "&project_id=" +
        this.project_id +
        "&date_type=" +
        this.date_type +
        "&start_date=" +
        this.start_date +
        "&end_date=" +
        this.end_date;
    },
    detailPage(item) {
      console.log(item);
      this.detailVal = item;
      this.showIsDetail = true;
    },
    hideIsDetail(msg) {
      this.showIsDetail = false;
      if (msg) {
        this.reload();
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    hideInAdd(msg) {
      this.showIsAdd = false;
      if (msg) {
        this.reload();
      }
    },
    backHref() {
      this.showIsDetail = false;
      this.showIsAdd = false;
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.project_id = "";
      this.query_field = "";
      this.start_date = "";
      this.end_date = "";
      this.date_type = 1;
      this.dateVal = null;
      this.status = "";
      this.type = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Work_order/orderlist";
      let params = {
        current_page: this.page,
        per_page: 10,
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: this.project_id,
        query_field: this.query_field,
        status: this.status,
        date_type: this.date_type,
        start_date: this.start_date,
        end_date: this.end_date,
        type: this.type
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
